<template>
    <b-modal
        v-model="modal"
        :id="'bars-rubric-details-modal'"
        :ref="'bars-rubric-details-modal'"
        :title="$t('survey.result_details')"
        :ok-title="$t('common.close')"
        ok-only
        size="xl"
        modal-class="apprentice-default-modal">
        <div>
            <design-2021-rubric-form-component
                :rubric-in="rubric"
                :rubric-form-in="form"
                :edit="false"
                :show-other-results="true">
            </design-2021-rubric-form-component>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-survey-results-index-rubric-modal-component',
    data() {
        return {
            modal: false,
            rubric: null,
            form: null,
        };
    },
    methods: {
        show(response) {
            this.rubric = response.rubric;
            this.form = response.rubric_form;
            this.modal = true;
        },
    },
};
</script>

<style scoped></style>
